import Vue from "vue";
import imageZoom from "vue-image-zoomer";

Vue.component("imageZoom", imageZoom);